/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductionPlanListPage = lazyLoad(
  () => import('./index'),
  module => module.ProductionPlanListPage
);
